import React from 'react';
import { Container, Paper, Typography, Button, Grid } from '@mui/material';
import styled from 'styled-components';

const PricingContainer = styled(Container)`
  padding: 2rem 0;
`;

const PricingCard = styled(Paper)`
  padding: 2rem;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const PriceAmount = styled(Typography)`
  font-size: 3rem;
  margin: 1rem 0;
`;

const Subscription = () => {
  const plans = [
    {
      name: '免费版',
      price: '¥0',
      features: ['基础简历模板', '最多保存3份简历', '基础导出功能'],
      buttonText: '当前方案'
    },
    {
      name: '高级版',
      price: '¥29/月',
      features: ['所有高级模板', '无限保存简历', '高级导出功能', '优先客服支持'],
      buttonText: '升级'
    }
  ];

  return (
    <PricingContainer>
      <Typography variant="h4" align="center" gutterBottom>
        订阅方案
      </Typography>
      <Grid container spacing={4} style={{ marginTop: '2rem' }}>
        {plans.map((plan) => (
          <Grid item xs={12} md={6} key={plan.name}>
            <PricingCard>
              <div>
                <Typography variant="h5">{plan.name}</Typography>
                <PriceAmount>{plan.price}</PriceAmount>
                {plan.features.map((feature) => (
                  <Typography key={feature} paragraph>
                    {feature}
                  </Typography>
                ))}
              </div>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
              >
                {plan.buttonText}
              </Button>
            </PricingCard>
          </Grid>
        ))}
      </Grid>
    </PricingContainer>
  );
};

export default Subscription; 